<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useRoute, useRouter } from '@/router/router';
import Vue from 'vue';
import { useNotifications } from '@/modules/notifications/composables/use-notifications';

const props = defineProps<{
  notificationTitle: string;
}>();

const router = useRouter();
const route = useRoute();

const {
  lastNotification,
  unreadNotificationCount,
  fetchMyNotificationCounts,
  markNotificationRead,
} = useNotifications();

watch(lastNotification, (notification) => {
  if (notification === null) return;

  // https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification#Parameters
  Vue.prototype.$notification.show(
    props.notificationTitle,
    {
      body: notification.message,
      icon: '/favicon.ico',
      requireInteraction: false,
    },
    {
      onclick: () => {
        if (notification.notificationOnClick != null) {
          // @TODO shouldn't hardcode paths in the backend
          // instead use route names, so that we can update paths as needed
          void router.push({
            path: notification.notificationOnClick,
            params: {},
          });
        }

        // clicking the browser notification marks the original notification as 'read'
        if (notification.notificationRefID != null) {
          void markNotificationRead([notification.notificationRefID]);
        }
      },
    }
  );
});

onMounted(async () => {
  await fetchMyNotificationCounts();
});

function handleBellClick(): void {
  if (route.name === 'notifications') {
    router.back();
  } else {
    void router.push({ name: 'notifications' });
  }
}
</script>

<template>
  <div>
    <VBtn icon small @click="handleBellClick">
      <VBadge
        v-if="unreadNotificationCount > 0"
        color="error"
        :content="unreadNotificationCount"
        overlap
      >
        <VIcon data-test-id="notification-icon">mdi-bell</VIcon>
      </VBadge>
      <VIcon v-else>mdi-bell</VIcon>
    </VBtn>
  </div>
</template>

<style lang="scss" scoped></style>
